// extracted by mini-css-extract-plugin
module.exports = {"root":"AboutRoom_root__1GOsQ","innerCardAction":"AboutRoom_innerCardAction__3w0fh"};